(() => {
  const initContactForm = (form) => {
    if (!form || form.dataset.vqContactInit === 'true') return;

    const firstName = form.querySelector('[data-contact-first-name]');
    const lastName = form.querySelector('[data-contact-last-name]');
    const fullName = form.querySelector('[data-contact-full-name]');

    if (!firstName || !lastName || !fullName) {
      form.dataset.vqContactInit = 'true';
      return;
    }

    const syncFullName = () => {
      const first = firstName.value.trim();
      const last = lastName.value.trim();
      fullName.value = `${first} ${last}`.trim();
    };

    firstName.addEventListener('input', syncFullName);
    lastName.addEventListener('input', syncFullName);
    form.addEventListener('submit', syncFullName);
    syncFullName();

    form.dataset.vqContactInit = 'true';
  };

  const initAll = (root = document) => {
    root.querySelectorAll('.contact-form__form').forEach(initContactForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
